import React from "react";
import styles from "styles/sponsors.module.css";

export default function SponsorCard({ data }) {
  const onClickHandler = () => {
    if (data.link && data.link !== "." && data.link !== " ") {
      window.open(data.link, "_blank");
    }
  };

  return (
    <div className={styles.gridItem}>
      <div className={styles.card} onClick={onClickHandler}>
        <div className={styles.card_image}>
          <img
            src={`https://edge-results.s3.ap-south-1.amazonaws.com/sponsor/${data._id}.jpg`}
            alt=""
            className="bg-white"
          />
        </div>

        <div className={styles.card_details}>
          <h2 className="capitalize">{data.name}</h2>
          {data.tag && data.tag !== "." && (
            <p
              className={`text-center text-white text-xs my-2 ${styles.tagline}`}
            >
              {data.tag}
            </p>
          )}
          {data.link && data.link !== "." && data.link !== " " && (
            <p className="text-center text-sm text-red underline">Visit</p>
          )}
        </div>
      </div>
    </div>
  );
}
